
import { defineComponent } from 'vue';
import { FIcon } from '@/components/common';

export default defineComponent({
  components: {
    FIcon,
  },
  props: {
    /** 是否禁用 */
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      value: '',
    };
  },
  methods: {
    handleClickTextField() {
      if (this.disabled) {
        return;
      }
      (this.$refs.input as HTMLInputElement).focus();
    },
    handleKeyDown(e: KeyboardEvent) {
      // TODO: 如何在移动端监听键盘“完成”按钮？
      // 监听回车键
      if (e.key === 'Enter') {
        this.search();
      }
    },
    search() {
      if (this.disabled) {
        return;
      }
      // 在搜索页面再次触发搜索，不重复堆叠页面栈
      if (this.$route.path === '/rating/search') {
        this.$router.replace({ path: '/rating/search', query: { q: this.value } });
      } else {
        this.$router.push({ path: '/rating/search', query: { q: this.value } });
      }
    },
  },
});
